import React from 'react';
import { LockIcon, ShieldCheckIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { valueStack, TOTAL_VALUE, PRICE, CHECKOUT_URL } from '../data/content';
export function PricingSection() {
  return <section id="pricing" aria-labelledby="precios" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-12 text-center" data-id="element-178" data-mp="1j9gyaqilbf9w">
      <Reveal className="flex flex-col items-center gap-2" data-id="element-179" data-mp="1naalfho7kq1q">
        <span className="inline-flex items-center gap-2 rounded-full bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-blush" data-id="element-180" data-mp="1s8u7di2sy1u3">
          <SparklesIcon size={14} data-id="element-181" data-mp="1x6vqg308a15k" />
          Oferta especial
        </span>
        <h2 id="precios" className="font-display text-2xl md:text-3xl font-bold uppercase text-ink" data-id="element-182" data-mp="227b5cz05rgpn">
          Todo lo que recibís
        </h2>
      </Reveal>

      <Reveal delay={0.05} className="mx-auto mt-6 max-w-2xl rounded-3xl border border-accent/25 bg-surface p-6 md:p-8" data-id="element-183" data-mp="7ul94ambhvf3">
        <ul className="divide-y divide-line" data-id="element-184" data-mp="1hpy97xpcd6pn">
          {valueStack.map(row => <li key={row.item} className="flex items-center justify-between gap-4 py-3 text-left text-sm md:text-base text-ink" data-id="element-185" data-mp="1ho510dz2yefj">
              <span data-id="element-186" data-mp="17td3191l5pk8">{row.item}</span>
              <span className="flex-shrink-0 font-semibold text-ink-muted" data-id="element-187" data-mp="25fitql158c11">
                {row.value}
              </span>
            </li>)}
        </ul>

        <p className="mt-5 text-sm font-bold uppercase tracking-[0.16em] text-ink-subtle" data-id="element-188" data-mp="20gz5uf2zoq61">
          Valor total{' '}
          <span className="line-through decoration-danger" data-id="element-189" data-mp="1vjfrzga7efem">{TOTAL_VALUE}</span>
        </p>
        <p className="mt-1 text-sm text-ink-muted" data-id="element-190" data-mp="1rfhq4xthuqhv">
          Hoy no pagás {TOTAL_VALUE}
        </p>

        <p className="mt-4 flex items-baseline justify-center gap-2" data-id="element-191" data-mp="k03abmfrqnxi">
          <span className="font-display text-5xl md:text-6xl font-bold text-accent" data-id="element-192" data-mp="fzt6afbje7la">
            {PRICE}
          </span>
          <span className="text-lg font-semibold text-ink-muted" data-id="element-193" data-mp="hijbz8uhj2wj">ARS</span>
        </p>
        <p className="mt-1 text-xs font-bold uppercase tracking-[0.24em] text-blush" data-id="element-194" data-mp="mgcjc57iy2ye">
          Pago único
        </p>

        <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-6" data-id="element-195" data-mp="7lofevhrvckw">
          Quiero mi Mega Pack Vuelve a Ti™
        </CtaButton>

        <div className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-ink-muted" data-id="element-196" data-mp="3uw4ksitdi2ib">
          <span className="flex items-center gap-1.5" data-id="element-197" data-mp="3j1wxl6zr40d">
            <LockIcon size={14} className="text-ink-subtle" data-id="element-198" data-mp="3jtjy7mivtf1" />
            Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-199" data-mp="3pxkyghavaopf">
            <ZapIcon size={14} className="text-gold" data-id="element-200" data-mp="3pycwdyrxsyiv" />
            Acceso digital inmediato
          </span>
          <span className="flex items-center gap-1.5" data-id="element-201" data-mp="3bybtyew0xj1a">
            <ShieldCheckIcon size={14} className="text-success" data-id="element-202" data-mp="3fzx3bq9cnf6q" />
            Garantía 7 días
          </span>
        </div>
      </Reveal>
    </section>;
}